"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Role = void 0;
var Role;
(function (Role) {
    Role[Role["ADMIN"] = 0] = "ADMIN";
    Role[Role["MANAGER"] = 1] = "MANAGER";
    Role[Role["EXECUTOR"] = 2] = "EXECUTOR";
    Role[Role["SYSTEM_ADMIN"] = 3] = "SYSTEM_ADMIN";
    Role[Role["CONTACT"] = 4] = "CONTACT";
    Role[Role["SELF_EMPLOYED"] = 5] = "SELF_EMPLOYED";
})(Role = exports.Role || (exports.Role = {}));
//# sourceMappingURL=role.enum.js.map